import {
  AfterViewInit,
  Component,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BaseComponent } from '@app/shared/base/base-component/base-component.component';
import { BaseProductComponent } from '@product/shared/base-product.component';
import { ConfigurationProduct } from '@product/shared/models/ConfigurationProduct';
import { DropDownOption } from '@product/shared/models/GlobalInterfaces';
import { Product } from '@product/shared/models/product';
import { CommonService } from '@product/shared/services/common.service';
import { ProductService } from '@product/shared/services/product.service';
import { switchMap, tap } from 'rxjs';
import { HardCopy } from 'src/global-variables';
@Component({
  selector: 'app-configurable-product',
  templateUrl: './configurable-product.component.html',
  styleUrls: ['./configurable-product.component.less'],
})
export class ConfigurableProductComponent
  extends BaseProductComponent
  implements OnInit, AfterViewInit
{
  _formgroup: FormGroup;
  @Input() set formGroup(value: FormGroup) {
    this._formgroup = value;
  }
  get formGroup() {
    return this._formgroup;
  }

  @Input() Disabled = false;
  @Output() selectedProductsEmitter = new EventEmitter();
  attributeInputs: { id: number }[] = [];
  attributes: DropDownOption[] = [];
  attributesCount: number;
  baseAttributesCopy: DropDownOption[] = [];
  products: any[] = [];
  checked = false;
  loading = false;
  indeterminate = false;
  showNoData: boolean = false;
  setOfCheckedId = new Set<number>();
  attributeOptionsMetadata: { [key: number]: any[] } = {};
  showAttributeSetWarning = true;
  constructor(
    injector: Injector
  ) {
    super(injector);
  }
  ngAfterViewInit(): void {
    // console.log(this.route.snapshot.params);
    const formValues$ = this.formGroup.valueChanges.subscribe((data) => {
      if (data.configurableProductProducts == null) {
        return;
      }
      const products = this.formGroup.get('configurableProductProducts')!
        .value as ConfigurationProduct[];
      const attributes = products
        .map((x) => x.configProductAttributes.map((z: any) => z.attributeId))
        .filter((value, index, self) => self[0].indexOf(value[0]) === index);
      this.attributeInputs = attributes.map((x) => {
        return { id: x[0] };
      });
      this.setOfCheckedId = new Set<number>(
        products.map((x: any) => x.childProductId)
      );
      this.refreshCheckedStatus();
      this.getProducts();
      formValues$.unsubscribe();
    });
  }
  //#region checkbox
  refreshCheckedStatus(): void {
    this.checked =
      this.products.length > 0 &&
      this.products.every((prod) => this.setOfCheckedId.has(prod.Id!));
    this.indeterminate =
      this.products.some((prod) => this.setOfCheckedId.has(prod.Id!)) &&
      !this.checked;
  }
  updateCheckedSet(id: number, checked: boolean): void {
    if (checked) {
      this.setOfCheckedId.add(id);
    } else {
      this.setOfCheckedId.delete(id);
    }
    this.selectedProductsEmitter.emit({
      products: Array.from(this.setOfCheckedId),
      attributes: this.attributeInputs.map((x) => x.id),
    });
  }
  onItemChecked(id: number, checked: boolean): void {
    this.updateCheckedSet(id, checked);
    this.refreshCheckedStatus();
  }
  onAllChecked(checked: boolean): void {
    this.products.forEach((prod) => this.updateCheckedSet(prod.Id!, checked));
    this.refreshCheckedStatus();
  }
  //#endregion

  ngOnInit() {
    const value = this.formGroup.get('attributeSetId')?.value;

    if (value != null) {
      this.getAttributes(value);
      this.showAttributeSetWarning = false;
    } else {
      this.showAttributeSetWarning = true;
    }
    this.formGroup.get('attributeSetId')?.valueChanges.subscribe((value) => {
      if (value != null) {
        this.getAttributes(value);
        this.showAttributeSetWarning = false;
      } else {
        this.showAttributeSetWarning = true;
      }
    });
  }

  getAttributes(attributeSetId: number) {
    const attributes$ = this.attributesService
      .getConfigurableAttributes(attributeSetId)
      .pipe(
        tap((response) => {
          this.attributes = response;
          this.attributesCount = HardCopy(this.attributes.length);
          this.baseAttributesCopy = HardCopy(this.attributes);
          if (this.formGroup.controls['']) {
          }
        })
      )
      .subscribe();
    this.subscriptions.push(attributes$);
  }
  addAttributeInput() {
    this.attributeInputs = [...this.attributeInputs, { id: 0 }];
  }
  onChoosingAttribute(event: any) {
    this.attributes = this.baseAttributesCopy.filter(
      (x) => !this.attributeInputs.map((x) => x.id).includes(+x.Code)
    );
  }
  reset() {
    this.attributeInputs = [];
    this.products = [];
    this.setOfCheckedId.clear();
    this.refreshCheckedStatus();
    this.checked = false;
    this.attributes = this.baseAttributesCopy;
    this.showNoData = false;
  }
  getProducts() {
    if (this.attributeInputs.length == 0) {
      this.notification.warning(
        'No chosen attributes',
        'Please choose at least one attribute'
      );
      return;
    } else if (this.attributeInputs.some((x) => x.id == 0)) {
      this.notification.warning(
        'Attribute has no value',
        'One of the attributes has no value, please choose a value and try to get products again'
      );
      return;
    }
    const ids = this.attributeInputs.map((x) => x.id);
    this.productService
      .getConfigurationProducts(ids)
      .pipe(
        tap((response) => {
          this.products = response;
          this.showNoData = true;
        }),
        switchMap(() => this.commonService.getAttributesOptions(ids)),
        tap((resp) => {
          Object.keys(resp).forEach((attId) => {
            this.attributeOptionsMetadata[+attId] = resp[+attId].map(
              (option) => {
                return {
                  Code: option.id,
                  Label: option.value ?? option.name,
                };
              }
            );
          });
        })
      )
      .subscribe();
  }

  deleteAttrubyteInput(input: { id: number }) {
    this.attributeInputs = this.attributeInputs.filter((x) => x != input);
    const option = this.baseAttributesCopy.find((x) => x.Code == input.id);
    if (option != null) this.attributes.push(option);
  }
}
